import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SelectFieldFloatingLabel as Select } from "../../../../../common/custom-form/select-filter.component";
import Icons from "../../../../../icon";
import { LABEL_FORMAT, TABLE_WARNING_ICON, MAX_LENGTH, EXCEPTION_STATUS } from "../../../../../../constants/external-constants";
import { TextArea } from "../../../../../common/custom-form/custom-textarea.component";
import { invoiceAuditRulesActions } from "../../../../../../store/external/invoice/invoice/audit-table.reducer";
import Translation from '../../../../../common/translation/translation.component';
import { Loading } from "../../../../../common/loading/index";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
class Exception extends Component {
    constructor(props) {
        super(props);
        this.state={
            additionalInformation: "",
            statusValue: '1',
            showExceptionModal: false,
            showAuditRule: false,
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    convertDataToArray(data) {
        return Object.keys(data).map(key => {
            return { section: key, details: data[key] };
        });
    }

    onChangeAdditionalInfoText = (e) => {
        this.setState({ additionalInformation: e.target.value });
        const { onChangeAdditionalInfoText } = this.props;
        onChangeAdditionalInfoText(e.target.value); 
    }
    componentDidMount() {
        const { invoiceDetailsId, getInvoiceAuditRulesDetails, auditDetailsId, exceptionId, exceptionStatusId, onChangeStatusSelect, onChangeAdditionalInfoText, additionalInformationValue } = this.props;
        getInvoiceAuditRulesDetails(invoiceDetailsId, auditDetailsId, exceptionId);
        this.setState({ statusValue: exceptionStatusId, additionalInformation: additionalInformationValue  });
        onChangeStatusSelect(exceptionStatusId, auditDetailsId);
        onChangeAdditionalInfoText(additionalInformationValue);
    }
    componentWillUnmount() {
        const { invoiceDetailsId, getAuditChartData, resetInvoiceAuditRulesDetails, getInvoiceAuditRules } = this.props;
        resetInvoiceAuditRulesDetails();
        getAuditChartData(invoiceDetailsId);
    }
    onChangeStatusSelect = (indicator, item) => {   
        const { onChangeStatusSelect, auditDetailsId, exceptionStatusId } = this.props;
        if (exceptionStatusId != EXCEPTION_STATUS.invalid.id) {
            this.setState({ statusValue: item });
            onChangeStatusSelect(item, auditDetailsId);
        }

    }
    render() {
        const { invoiceAuditRules, exceptionFlag, exceptionStatusId } = this.props;
        const { isInvoiceAuditRulesDetailsLoaded, exceptionStatusList } = this.props.invoiceAuditRules;
        const { statusValue, additionalInformation } = this.state;
        return (
            <>
            { isInvoiceAuditRulesDetailsLoaded ?
                    <div className=" audit-exception-modal details-container">
                        <div className="details-container__status">
                            <Select
                                className="form-select required"
                                label={<Translation translationKey='status_capital'/>}
                                options={exceptionStatusList}
                                value={statusValue}
                                placeholder={"Valid"}
                                isError={false}
                                fieldProp='props.field'
                                onChangeAction={this.onChangeStatusSelect}
                                optionLabelKey={{
                                    Key: "Id",
                                    Value: "Name"
                                }}
                                disabled={exceptionStatusId != EXCEPTION_STATUS.invalid.id ? false : true}
                            />
                            {exceptionFlag &&
                                <div className="icon__warning">
                                    <Icons
                                        customClassName="icon-header-check-reg"
                                        name="circle-exlamation-warning"
                                        size="18px"
                                        containerClass="icon-circle-check-container"
                                    />
                                    <div className="icon__tooltip">
                                        <span>
                                            {TABLE_WARNING_ICON.AUDIT_TABLE.tooltip}
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="details-audit-container  data-table">
                            {invoiceAuditRules.isInvoiceAuditRulesDetailsLoaded &&
                                this.convertDataToArray(invoiceAuditRules.auditRulesExceptionDetails.AuditRulesDetails).map((item, index) => (
                                    <div key={index} className="details-audit-container__details">
                                        <h1>{<Translation translationKey={LABEL_FORMAT[item.section]} />}</h1>
                                        <div className="details-audit-container__section">
                                            {
                                                Object.entries(item.details).map(([key, value], index) => (
                                                    <div key={index} className="section-wrapper">
                                                        <div className="section-container">
                                                            <span className="section__label">{<Translation translationKey={LABEL_FORMAT[key]} />} </span>
                                                        </div>
                                                        <div className="section-container">
                                                            <span className="section__value">{value != null && value !== "" ? value : "N/A"}</span>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <TextArea customClass="invoice-comment-text invoice-text"
                            label={<Translation translationKey='additional_information' />}
                            inputValue={additionalInformation}
                            maxLength={MAX_LENGTH.limit_255}
                            className={"input-filter-comment-padding"}  
                            placeholder={this.toLocaleLanguage('insert_text_placeholder')}
                            onChange={(e) => this.onChangeAdditionalInfoText(e)} />                           
                    </div>
             :   <Loading />}
            </>
        )
    }
}

export default connect(
    state => {
        const { invoiceAuditRules, translation } = state;

        return {
            invoiceAuditRules
            , ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceAuditRulesActions),
        dispatch
    )
)(Exception);